<template>
  <div class="modal-card" style="width: 800px height: 600px">
    <header class="modal-card-head">
      <p class="modal-card-title">Available Integrations</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <IntegrationsLinks />
    </section>
    <footer class="modal-card-foot">
      <b-button label="Close" @click="$emit('close')" />
    </footer>
  </div>
</template>

<script>
import IntegrationsLinks from './IntegrationsLinks.vue';

export default {
  name: 'IntegrationsModal',
  components: {
    IntegrationsLinks,
  },
  data() {
    return {
      loading: false,
      integrations: {},
    }
  },
  props: {
    advisor: Object,
  },
  watch: {
  },
  methods: {
    requestIntegration: async function(integration) {
        this.loading = true;

      let response = await fetch(
        `/api/v1/request-integration/`,
        {
          method: 'POST',
          headers: {
            'X-CSRFToken': this.$root.$data.csrfToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'integration': integration,
          }),
        }
      );
      let data = await response.json();
      this.success = data.success;
      this.loading = false;
      if(this.success) {
          window.open(data.integration_context.zoho_url, '_blank').focus();
          this.$emit('close')
      } 
      if(!this.success) {
          this.$buefy.notification.open({
            duration: 10000,
            message: `Seems we are having an issue doing that. Please try again. If it doesn't work, email us at support@yourstake.org`,
            position: 'is-bottom-right',
            type: 'is-danger',
          });
      }
    }
  },
}
</script>

<style lang="scss" scoped>

  .mygrid {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;

    .box {
      width: 150px;
      height: 150px;
      margin: 1rem;
    }
  }

  div > a > figure > img {
    margin: auto;
  }



</style>
